import axios, { AxiosResponse } from 'axios';
import axiosRetry from 'axios-retry';
import { db$ } from 'nike-re-framejs';
import { NikeJwtToken } from '../../types/jwtToken';
import { clientLog } from '../logging/logs';
import { XhrLog } from '../logging/XhrLog';

const TIME_FOR_REFRESH_BEFORE_JWT_EXPIRATION = 5 * 60 * 1000;

export const JWT_ANONYMOUS_USER = 'ANONYMOUS_USER';
const currentUserMobile = () => db$.value.getIn(['account', 'userData', 'idZak']);
const currentUserPortal = () => db$.value.getIn(['account', 'user', 'contractNumber']);
const currentUser = () => currentUserMobile() || currentUserPortal() || JWT_ANONYMOUS_USER;

const tokenClient = axios.create({
    baseURL: '/api/security-token'
});

axiosRetry(tokenClient, {
    retryDelay: axiosRetry.exponentialDelay,
    retries: Infinity,
    onRetry: (retryCount, error) => {
        clientLog(
            XhrLog({
                message: `${retryCount} retry for failed /api/security-token`,
                data: { error }
            })
        );
    }
});

export const jwtTokenPromise = () => {
    if (!window.nikeJwtToken && window.OPTIONS.jwtToken) {
        window.nikeJwtToken = window.OPTIONS.jwtToken;
        window.nikeJwtToken.clientIssueTime = Date.now();
    }
    return window.nikeJwtToken && isJwtValid(window.nikeJwtToken)
        ? Promise.resolve(window.nikeJwtToken.token)
        : securityTokenPendingPromise || getSecurityToken();
};

function isJwtValid(jwt) {
    const refreshTimeLimit = Math.max(
        jwt.expirationInterval - TIME_FOR_REFRESH_BEFORE_JWT_EXPIRATION,
        jwt.expirationInterval / 2
    );
    const tokenAliveTime = Date.now() - jwt.clientIssueTime;
    const userValid = jwt.user === String(currentUser());
    const ttlValid = tokenAliveTime < refreshTimeLimit;
    return userValid && ttlValid;
}

let securityTokenPendingPromise: Promise<string> | null = null;

function getSecurityToken() {
    return (securityTokenPendingPromise = tokenClient
        .get<never, AxiosResponse<NikeJwtToken>>('')
        .then(response => {
            window.nikeJwtToken = response.data;
            window.nikeJwtToken.clientIssueTime = Date.now();
            return window.nikeJwtToken.token;
        })
        .finally(() => {
            securityTokenPendingPromise = null;
        }));
}
